export const auth = (
  state = {
    isLogin: false,
  },
  action
) => {
  switch (action.type) {
    case "SET_USER_DATA":
      console.log("resres", action.data);

      if (!!action.data) {
        localStorage.setItem("ud", JSON.stringify(action.data));
        localStorage.setItem(
          "accessType",
          JSON.stringify(action.data.master[0].access_type)
        );

        return {
          ...action.data,
          isLogin: true,
        };
      }
      return {
        ...action.data,
        isLogin: false,
      };

    default:
      return state;
  }
};

export const schoolCode = (
  state = {
    status: "",
    msg: "",
    sch_id: "2",
    sch_code: "",
    sch_name: "",
  },
  action
) => {
  switch (action.type) {
    case "SET_SCHOOL_CODE":
      return action.data;
    default:
      return state;
  }
};
